import Vue from "vue";
import lazyContainerFactory from "@core/lazy-container-factory";

// export const MultiPanel = lazyContainerFactory({
//    name: "multi-panel",
//    componentLoader: () =>
//       import(/* webpackChunkName: "multi-panel" */ `@components/multi-panel`),
// });

// export const PageHeader = lazyContainerFactory({
//    name: "page-header",
//    componentLoader: () =>
//       import(/* webpackChunkName: "page-header" */ `@components/page-header`),
// });

// export const PageTitle = lazyContainerFactory({
//    name: "page-title",
//    componentLoader: () =>
//       import(/* webpackChunkName: "page-title" */ `@components/page-title`),
// });

// export const FloatingCTA = lazyContainerFactory({
//    name: "floating-cta",
//    componentLoader: () =>
//       import(/* webpackChunkName: "floating-cta" */ `@components/floating-cta`),
// });

// export const CounterButton = lazyContainerFactory({
//    name: "counter-button",
//    componentLoader: () =>
//       import(
//          /* webpackChunkName: "counter-button" */ `@components/counter-button`
//       ),
// });

// export const RollupComponent = lazyContainerFactory({
//    name: "rollup-component",
//    componentLoader: () =>
//       import(
//          /* webpackChunkName: "rollup-component" */ `@components/rollup-component`
//       ),
// });

Vue.component(
   "PageHeader",
   lazyContainerFactory({
      name: "page-header",
      minHeight: { xs: 40, sm: 40, md: 75, lg: 75, xl: 75 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "page-header" */ `@components/page-header`
         ),
   })
);

Vue.component(
   "PageTitle",
   lazyContainerFactory({
      name: "page-title",
      minHeight: { xs: 24, sm: 24, md: 28, lg: 40, xl: 56 },
      componentLoader: () =>
         import(/* webpackChunkName: "page-title" */ `@components/page-title`),
   })
);

Vue.component(
   "FloatingCTA",
   lazyContainerFactory({
      name: "floating-cta",
      minHeight: { xs: 30, sm: 30, md: 40, lg: 40, xl: 40 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "floating-cta" */ `@components/floating-cta`
         ),
   })
);

// Vue.component(
//    "CounterButton",
//    lazyContainerFactory({
//       name: "counter-button",
//       minHeight: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
//       componentLoader: () =>
//          import(
//             /* webpackChunkName: "counter-button" */ `@components/counter-button`
//          ),
//    })
// );

// Vue.component(
//    "RollupComponent",
//    lazyContainerFactory({
//       name: "rollup-component",
//       minHeight: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
//       componentLoader: () =>
//          import(
//             /* webpackChunkName: "rollup-component" */ `@components/rollup-component`
//          ),
//    })
// );

Vue.component(
   "MultiPanel",
   lazyContainerFactory({
      name: "multi-panel",
      minHeight: { xs: 100, sm: 100, md: 100, lg: 100, xl: 100 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "multi-panel" */ `@components/multi-panel`
         ),
   })
);

Vue.component(
   "Engagement",
   lazyContainerFactory({
      name: "engagement",
      minHeight: { xs: 353, sm: 353, md: 465, lg: 500, xl: 500 },
      componentLoader: () =>
         import(/* webpackChunkName: "engagement" */ `@components/engagement`),
   })
);

Vue.component(
   "SingleColumnContent",
   lazyContainerFactory({
      name: "single-column-content",
      minHeight: { xs: 60, sm: 60, md: 60, lg: 60, xl: 60 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "single-column-content" */ `@components/single-column-content`
         ),
   })
);

Vue.component(
   "MortgageRateTable",
   lazyContainerFactory({
      name: "mortgage-rate-table",
      minHeight: { xs: 422, sm: 422, md: 422, lg: 374, xl: 374 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "mortgage-rate-table" */ `@components/mortgage-rate-table`
         ),
   })
);

// Vue.component(
//    "Accordion",
//    lazyContainerFactory({
//       name: "accordion",
//       minHeight: { xs: 80, sm: 80, md: 80, lg: 80, xl: 80 },
//       componentLoader: () =>
//          import(/* webpackChunkName: "accordion" */ `@components/accordion`),
//    })
// );

Vue.component(
   "Collapsible",
   lazyContainerFactory({
      name: "collapsible",
      minHeight: { xs: 80, sm: 80, md: 80, lg: 80, xl: 80 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "collapsible" */ `@components/collapsible`
         ),
   })
);

Vue.component(
   "ContentBlock",
   lazyContainerFactory({
      name: "content-block",
      minHeight: { xs: 80, sm: 80, md: 80, lg: 80, xl: 80 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "content-block" */ `@components/content-block`
         ),
   })
);

Vue.component(
   "AdPanels",
   lazyContainerFactory({
      name: "ad-panels",
      minHeight: { xs: 620, sm: 620, md: 80, lg: 80, xl: 80 },
      componentLoader: () =>
         import(/* webpackChunkName: "ad-panels" */ `@components/ad-panels`),
   })
);

Vue.component(
   "BulletSection",
   lazyContainerFactory({
      name: "bullet-section",
      minHeight: { xs: 80, sm: 80, md: 80, lg: 80, xl: 80 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "bullet-section" */ `@components/bullet-section`
         ),
   })
);

Vue.component(
   "LoanNavigator",
   lazyContainerFactory({
      name: "loan-navigator",
      minHeight: { xs: 453, sm: 453, md: 453, lg: 453, xl: 453 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "loan-navigator" */ `@components/loan-navigator`
         ),
   })
);

Vue.component(
   "Video",
   lazyContainerFactory({
      name: "video",
      minHeight: { xs: 453, sm: 453, md: 453, lg: 453, xl: 453 },
      componentLoader: () =>
         import(/* webpackChunkName: "video" */ `@components/video`),
   })
);

Vue.component(
   "Faq",
   lazyContainerFactory({
      name: "faq",
      minHeight: { xs: 620, sm: 620, md: 620, lg: 200, xl: 200 },
      componentLoader: () =>
         import(/* webpackChunkName: "faq" */ `@components/faq`),
   })
);

Vue.component(
   "ContentList",
   lazyContainerFactory({
      name: "content-list",
      minHeight: { xs: 200, sm: 200, md: 200, lg: 200, xl: 200 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "content-list" */ `@components/content-list`
         ),
   })
);

Vue.component(
   "PowerFooter",
   lazyContainerFactory({
      name: "power-footer",
      minHeight: { xs: 200, sm: 200, md: 200, lg: 200, xl: 200 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "power-footer" */ `@components/power-footer`
         ),
   })
);

Vue.component(
   "Disclosures",
   lazyContainerFactory({
      name: "disclosures",
      minHeight: { xs: 100, sm: 100, md: 100, lg: 100, xl: 100 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "disclosures" */ `@components/disclosures`
         ),
   })
);

Vue.component(
   "FooterNavigation",
   lazyContainerFactory({
      name: "footer-navigation",
      minHeight: { xs: 50, sm: 50, md: 50, lg: 50, xl: 50 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "footer-navigation" */ `@components/footer-navigation`
         ),
   })
);

Vue.component(
   "FooterCopyright",
   lazyContainerFactory({
      name: "footer-copyright",
      minHeight: { xs: 42, sm: 42, md: 50, lg: 50, xl: 50 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "footer-copyright" */ `@components/footer-copyright`
         ),
   })
);

Vue.component(
   "ShadowHeader",
   lazyContainerFactory({
      name: "shadow-header",
      minHeight: { xs: 42, sm: 42, md: 50, lg: 50, xl: 50 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "shadow-header" */ `@components/shadow-header`
         ),
   })
);

Vue.component(
   "ThreeColumnCenterImage",
   lazyContainerFactory({
      name: "three-column-center-image",
      minHeight: { xs: 600, sm: 600, md: 500, lg: 400, xl: 400 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "three-column-center-image" */ `@components/three-column-center-image`
         ),
   })
);

Vue.component(
   "StateSelector",
   lazyContainerFactory({
      name: "state-selector",
      minHeight: { xs: 100, sm: 100, md: 50, lg: 50, xl: 50 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "state-selector" */ `@components/state-selector`
         ),
   })
);

Vue.component(
   "IntroductoryRates",
   lazyContainerFactory({
      name: "introductory-rates",
      minHeight: { xs: 330, sm: 330, md: 330, lg: 200, xl: 200 },
      componentLoader: () =>
         import(
            /* webpackChunkName: "introductory-rates" */ `@components/introductory-rates`
         ),
   })
);
